import dayjs from "dayjs";

export function HostNewEnquiry({ thread }) {
  if (thread.concierge) {
    return `${thread._concierge.fullName} on behalf of ${
      thread._organiser.fullName
    } has made an enquiry for
     ${thread._space.name} on the ${dayjs(thread.localDates.from).format(
      "D MMM YYYY"
    )}
      at ${dayjs(thread.localDates.from).format("HH:mm")}`;
  }

  return "You've received a new enquiry!";
}

export function OrganiserNewEnquiry({ thread }) {
  if (thread.concierge) {
    return `${
      thread._concierge.fullName
    } enquired on your behalf to the venue host ${
      thread._host ? `, ${thread._host.name}` : ""
    }. 
    Someone will be in touch as soon as possible. You will be able to see their response here when they reply. If you need a quick response,
    please use the call button above to get in touch with the venue directly`;
  }

  return `Someone from ${thread._venue.name} will respond to your enquiry shortly. You can also call them using the Call button`;
}
